module.exports = __webpack_public_path__ + "back.791ac22b.png";